
import React, { useState } from 'react';

const Orders: React.FC = () => {
  const [status, setStatus] = useState<'active' | 'pending' | 'closed'>('active');

  const orders = [
    { pair: 'BTC ⇄ USDT', amount: '600.00 USDT', total: '$50,000.00', sub: 'Sell at 44,789.59', status: 'Processing' },
    { pair: 'ETH ⇄ USDT', amount: '120.00 USDT', total: '$3,200.00', sub: 'Buy at 2,456.12', status: 'Processing' },
    { pair: 'SOL ⇄ USDT', amount: '50.00 USDT', total: '$4,100.00', sub: 'Sell at 102.45', status: 'Processing' },
  ];

  return (
    <div className="px-5 pt-12 pb-6 space-y-6">
      <h2 className="text-white font-bold text-2xl">Orders</h2>
      
      <div className="flex bg-zinc-900 rounded-full p-1">
        {(['active', 'pending', 'closed'] as const).map((s) => (
          <button
            key={s}
            onClick={() => setStatus(s)}
            className={`flex-1 py-2 text-xs font-bold rounded-full transition-all ${
              status === s ? 'bg-blue-600 text-white' : 'text-gray-500'
            }`}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>

      <div className="space-y-4">
        {orders.map((order, i) => (
          <div key={i} className="bg-zinc-900 p-5 rounded-3xl border border-zinc-800 space-y-4">
            <div className="flex justify-between items-start">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-orange-500/20 rounded-full flex items-center justify-center">
                   <span className="text-orange-500 font-bold">₿</span>
                </div>
                <div>
                  <h4 className="text-white font-bold text-sm">{order.pair}</h4>
                  <p className="text-gray-500 text-[10px]">{order.amount} * 100</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-white font-bold text-sm">{order.total}</p>
                <p className="text-gray-500 text-[10px]">{order.sub}</p>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex space-x-2">
                {['TL', 'SL', 'AL'].map(tag => (
                  <span key={tag} className="px-2 py-0.5 border border-zinc-700 rounded text-[9px] text-gray-500 font-bold">{tag}</span>
                ))}
              </div>
              <span className="text-orange-400 text-[10px] font-bold animate-pulse">{order.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Orders;
